'use client'
import { ContainerCustomV2 } from '@/components'
import ProductSlide from '@/features/home/components/product-slide'
import { useRecentProductStore } from '@/store/recent-products'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'

export default function ProductRecentlyViewed() {
  const { recentProducts } = useRecentProductStore()
  if (recentProducts.length === 0) {
    return null
  }
  return (
    <Box component={'section'}>
      <ContainerCustomV2 component={'div'}>
        <Stack gap={2}>
          <Typography variant="h2" sx={{ fontWeight: 600, fontSize: '2rem' }}>
            Sản phẩm đã xem gần đây
          </Typography>
          <Box>
            <ProductSlide
              classSwiper="swiper-recently-viewed-product"
              products={recentProducts}
              slidesPc={4}
              slidesTablet={3}
              slidesMobile={1.5}
              isSale={false}
            />
          </Box>
        </Stack>
      </ContainerCustomV2>
    </Box>
  )
}
